export enum Priority {
  Normal = 1,
  Medium = 2,
  High = 3,
}
